module.exports = __webpack_public_path__ + "static/media/roadsigns.0e58e918.jpg";